import { render, staticRenderFns } from "./NewThreadModal.vue?vue&type=template&id=01851dda"
import script from "./NewThreadModal.vue?vue&type=script&lang=ts"
export * from "./NewThreadModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01851dda')) {
      api.createRecord('01851dda', component.options)
    } else {
      api.reload('01851dda', component.options)
    }
    module.hot.accept("./NewThreadModal.vue?vue&type=template&id=01851dda", function () {
      api.rerender('01851dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/NewThreadModal.vue"
export default component.exports